// Scrollable

var jiren_scrollable = (function() {
  // Toggle the `has-scroll` class on every wrapper whose table currently
  // overflows its parent. Reads the live DOM each time, so swapped-in/removed
  // tables are handled automatically.
  function refreshAll() {
    $(".scrollable").each(function() {
      var wrapper = $(this);
      var element = wrapper.find("table, .tabs-list").first();
      if (!element.length) {
        return;
      }
      wrapper.toggleClass("has-scroll", element.outerWidth() > wrapper.outerWidth());
    });
  }

  // Wrap wide elements so they can scroll horizontally. `root` scopes the search
  // (defaults to the whole document); already-wrapped elements are skipped so
  // this is safe to re-run after content is swapped in via AJAX.
  function scrollable(root) {
    var $scope = root ? $(root) : $(document);

    $scope.find("table, .tabs-list").each(function() {
      var element = $(this);

      // Idempotent: leave anything already inside a wrapper alone.
      if (element.closest(".scrollable").length) {
        return;
      }

      // Create the wrapper element
      var scrollWrapper = $("<div />", {
        class: "scrollable",
        html: "<div />" // The inner div is needed for styling
      }).insertBefore(element);

      // Move the scrollable element inside the wrapper element
      element.appendTo(scrollWrapper.find("div"));

      // Check if the element is wider than its parent and thus needs to be scrollable
      scrollWrapper.toggleClass("has-scroll", element.outerWidth() > scrollWrapper.outerWidth());
    });
  }

  // One window handler for the lifetime of the page, bound once. Earlier this was
  // bound per-wrapped-table; the AJAX swap path (wrap) creates a fresh table on
  // every search, so per-table binding leaked a handler each time and threw on the
  // detached element on resize. A single handler that re-scans live wrappers avoids
  // both. `.off` first keeps it idempotent across turbolinks:load re-inits.
  $(window).off("resize.scrollable orientationchange.scrollable")
           .on("resize.scrollable orientationchange.scrollable", refreshAll);

  return {
    init: function() {
      scrollable();
    },
    // Wrap newly-inserted content (e.g. an AJAX-swapped result table).
    wrap: function(root) {
      scrollable(root);
    }
  };
})(this);

// Reachable from inline response scripts (rails-ujs) that swap in content.
global.jiren_scrollable = jiren_scrollable;

document.addEventListener("turbolinks:load", jiren_scrollable.init);
